import React from "react";
import { StyleSheet, Text, View } from "react-native";
import _ from "lodash";
import LazyView from './LazyView';

export default class ScrollableTabView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 0,
        };
    }

    render() {
        const { children, headerView, tabBarWidth, tabBarPosition,
                tabBarBackgroundColor, renderTabBar, ...props } = this.props;

        var tabProps = {
            tabs: [],
            activeTab: this.state.currentIndex,
            goToPage: (page) => {
                this.setState({currentIndex: page});
            },
        };

        var items = [];
        if (children) {
            var index = 0;
            for (let i = 0; i < children.length; ++i) {
                if (children[i]) {
                    const active = (this.state.currentIndex === index);
                    if (this.props.lazyRender) {
                        items.push(<View key={i} style={{flex: (active ? 1 : 0), overflow: 'hidden'}}>
                                       <LazyView visible={active} factory={() => children[i]}>
                                       </LazyView>
                                   </View>);
                    } else {
                        items.push(<View key={i} style={{flex: (active ? 1 : 0), overflow: 'hidden'}}>
                                       {children[i]}
                                   </View>);
                    }
                    tabProps.tabs.push(children[i].props.tabLabel);
                    index += 1;
                }
            }
        }
        return (<View {...props}>
                    {(renderTabBar && tabBarPosition === 'top') ? renderTabBar(tabProps) : null}
                    {items}
                    {(renderTabBar && tabBarPosition === 'bottom') ? renderTabBar(tabProps) : null}
                </View>);
    }
}

const styles = StyleSheet.create({
    container: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        flex:1,
    }
});
